import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IFile } from '../typing/file.interface';

@Injectable({
    providedIn: 'root'
})
export class FileService {

    constructor(private http: HttpClient) {
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<IFile>> {
        return this.http.get<IPaginatedResponse<IFile>>(`${environment.API_BASE_PATH}/files`, {params: query});
    }

    /**
     * Отправка заявки с приложенными фото/видео материалами.
     * @param orderId Данные заявки
     * @param files Массив файлов для загрузки
     */
    uploadOrdersFiles(orderId: number, files: FileList): Observable<IFile[]> {
        const formData = new FormData();

        // Добавляем данные заявки
        formData.append('orderId', orderId.toString());

        // Добавляем файлы в FormData
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i], files[i].name);
        }

        return this.http.post<IFile[]>(`${environment.API_BASE_PATH}/files`, formData);
    }
}
